import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';

import RangeDatePicker from '@/modules/Settlements/components/Main/Header/RangeDatePicker';
import { SettlementsContext } from '@/modules/Settlements/context/context';
import { WorkerSearch } from '@/modules/workingDayReconciliation';
import { Typography } from '@/shared/components/atoms';
import { CreateSettlement } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const Header = () => {
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store.asset);

  const {
    state: { endDate, startDate },
  } = useContext(SettlementsContext);

  return (
    <div className='mb-32 flex w-full flex-col gap-16'>
      <div className='flex items-center justify-between'>
        <Typography variant='h2' weight='bold'>
          {t('settlements')}
        </Typography>
        <CreateSettlement endDate={endDate} startDate={startDate} />
      </div>

      <div className='flex w-full items-center justify-between gap-2'>
        <RangeDatePicker />
        {selectedAsset?.settlementLevel === 2 ? (
          <WorkerSearch type='settlement' />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
export default Header;
